/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon16Light = forwardRef('MediaAudioVolumeS0Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.752 1.496A.75.75 0 0 1 9 2.056v11.887a.75.75 0 0 1-1.248.56L3.81 11H1.25C.56 11 0 10.44 0 9.75v-3.5C0 5.56.56 5 1.25 5h2.56l3.942-3.504ZM8 2.613 4.474 5.747A1 1 0 0 1 3.81 6H1.25a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h2.56a1 1 0 0 1 .664.253L8 13.387V2.613Z" })));
});
